import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/DiagnosticoResultado";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/diagnostico/resultado")({
  validateSearch: (search: Record<string, unknown>): { p?: string } => ({
    p: typeof search.p === "string" ? search.p : undefined,
  }),
  head: () => pageHead({ title: "Seu diagnóstico | Clara Camille", path: "/diagnostico/resultado", noindex: true }),
  component: () => {
    const { p } = Route.useSearch();
    return <Page perfilParam={p} />;
  },
});
